class FeatureListAutoRotate {
  constructor() {
    this.containers = document.querySelectorAll('.feature-list .section__content');
    this.rotationInterval = null;
    this.rotationDelay = 3500; // 3.5 seconds per item
    this.transitionDuration = 600; // 0.6 seconds fade transition
    this.isPaused = false;
    this.currentIndex = 0;
    
    this.init();
  }

  init() {
    this.containers.forEach(container => {
      this.setupAutoRotate(container);
    });
  }

  setupAutoRotate(container) {
    // Only enable auto-rotation on mobile devices
    if (window.innerWidth >= 768) {
      return;
    }

    const itemsContainer = container.querySelector('.feature-list__items');
    if (!itemsContainer) return;

    const items = itemsContainer.querySelectorAll('.feature-item');
    if (items.length <= 1) return; // Don't rotate if only one item

    // Check if auto-rotation is enabled via data attribute or section settings
    const section = container.closest('.feature-list');
    const enableAutoRotation = section?.dataset.enableAutoRotation !== 'false';
    
    if (!enableAutoRotation) return;

    // Add auto-rotate class to enable CSS transitions
    itemsContainer.classList.add('auto-rotate');
    
    // Initialize first item as active
    this.setActiveItem(items, 0);

    // Start auto-rotation
    this.startRotation(itemsContainer, items);

    // Pause on hover/touch
    this.setupPauseHandlers(container, itemsContainer, items);
  }

  setActiveItem(items, index) {
    // Remove active class from all items
    items.forEach(item => {
      item.classList.remove('active', 'fade-in', 'fade-out');
    });

    // Add active class to current item
    if (items[index]) {
      items[index].classList.add('active', 'fade-in');
    }
  }

  startRotation(itemsContainer, items) {
    this.rotationInterval = setInterval(() => {
      if (this.isPaused) return;

      // Fade out current item
      const currentItem = items[this.currentIndex];
      if (currentItem) {
        currentItem.classList.add('fade-out');
        currentItem.classList.remove('fade-in');
      }

      // Move to next item
      this.currentIndex = (this.currentIndex + 1) % items.length;

      // Fade in next item after transition
      setTimeout(() => {
        this.setActiveItem(items, this.currentIndex);
      }, this.transitionDuration / 2);
    }, this.rotationDelay);
  }

  setupPauseHandlers(container, itemsContainer, items) {
    // Pause on mouse enter/touch start
    const pauseRotation = () => {
      this.isPaused = true;
    };

    // Resume on mouse leave/touch end
    const resumeRotation = () => {
      this.isPaused = false;
    };

    // Mouse events
    container.addEventListener('mouseenter', pauseRotation);
    container.addEventListener('mouseleave', resumeRotation);

    // Touch events
    container.addEventListener('touchstart', pauseRotation);
    container.addEventListener('touchend', () => {
      // Resume after a short delay to prevent immediate restart
      setTimeout(resumeRotation, 1000);
    });

    // Manual swipe/drag detection
    let startX = 0;
    let isDragging = false;

    container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = false;
    });

    container.addEventListener('touchmove', (e) => {
      const currentX = e.touches[0].clientX;
      const diffX = Math.abs(currentX - startX);
      
      if (diffX > 10) { // Threshold for drag detection
        isDragging = true;
        this.isPaused = true;
      }
    });

    container.addEventListener('touchend', () => {
      if (isDragging) {
        // Resume after manual interaction
        setTimeout(() => {
          this.isPaused = false;
        }, 2000);
      }
    });
  }

  stopRotation() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval);
      this.rotationInterval = null;
    }
  }

  destroy() {
    this.stopRotation();
    this.containers.forEach(container => {
      const itemsContainer = container.querySelector('.feature-list__items');
      if (itemsContainer) {
        // Only remove auto-rotate classes on mobile
        if (window.innerWidth < 768) {
          itemsContainer.classList.remove('auto-rotate');
          const items = itemsContainer.querySelectorAll('.feature-item');
          items.forEach(item => {
            item.classList.remove('active', 'fade-in', 'fade-out');
          });
        }
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.featureListAutoRotate = new FeatureListAutoRotate();
});

// Re-initialize on window resize
window.addEventListener('resize', () => {
  // Small delay to ensure resize is complete
  setTimeout(() => {
    if (window.featureListAutoRotate) {
      window.featureListAutoRotate.destroy();
    }
    window.featureListAutoRotate = new FeatureListAutoRotate();
  }, 100);
}); 